import ModelEntity from "../model-entity"
import {EntityType} from "../../gd/const/item"
import ModelProxy from "../model-proxy"
import FieldsCollection from "../../fields3/collection/base/fields-collection"
import FieldProto from "../../fields3/proto/field-proto"
import ErrorProto from "../../gd/validation/error"
import ErrorFieldRequired from "../../gd/validation/error-field-required"
import ErrorFieldCustom from "../../gd/validation/error-field-custom"
import {FieldType} from "../../fields3/field-type"
import FieldConfig from "../../fields3/proto/field-config"
import {CustomEntityType} from "./@types"
import CustomEntity_ParamsDBNoToken from "./params/external-db-token-auth"
import ApiCustomEntity from "./api"

const nameFieldConfig: FieldConfig = {
    fieldId : 'name',
    label   : 'Name',
    type    : FieldType.STRING,
}

const debug = false
// const debug = "CustomEntity"

export default class CustomEntity extends ModelEntity {

    public name                 : string

    public fieldsConfig         : any

    public type                 : CustomEntityType

    public params               : CustomEntity_ParamsDBNoToken

    public _fieldsCollection?   : FieldsCollection
    public _titleField?         : FieldProto

    public _fieldsConfigString? : string    // is required for proper json validation

    constructor(data: any, useProxy = true) {

        super(data.id, EntityType.CUSTOM_ENTITY)

        this.name                   = data.name
        this.type                   = data.type || CustomEntityType.EXTERNAL_DB_TOKEN_AUTH
        this.fieldsConfig           = data.fieldsConfig

        this._fieldsConfigString    = this.fieldsConfigString

        switch (this.type) {
            case CustomEntityType.EXTERNAL_DB_TOKEN_AUTH:
            default:
                this.params     = new CustomEntity_ParamsDBNoToken(data?.params)
        }

        debug && console.log(debug, 'constructor', this._fieldsConfigString, this)

        return useProxy ? new Proxy(this, ModelProxy) : this
    }

    get isNewModel() {
        return !this.id
    }

    get fieldsCollection() {
        if (!this._fieldsCollection) {
            // add mandatory field 'name' config
            const nameField = _.clone(nameFieldConfig)
            if (this.params.nameFieldLabel) nameField.label = this.params.nameFieldLabel

            let fieldsConfig = [nameField]
            if (this.fieldsConfig) {
                fieldsConfig = fieldsConfig.concat(this.fieldsConfig)
            }
            fieldsConfig = _.compact(fieldsConfig)

            debug && console.log(debug, 'fieldsCollection fieldsConfig', fieldsConfig, this.fieldsConfig)

            this._fieldsCollection   = new FieldsCollection(fieldsConfig)
        }

        return this._fieldsCollection
    }

    get titleField() {
        if (!this._titleField) {
            this._titleField = this.fieldsCollection.get(nameFieldConfig.fieldId)
        }

        return this._titleField
    }

    set fieldsConfigString(value: string) {
        try {
            this.fieldsConfig = value !== '' ? JSON.parse(value) : value

            this._fieldsCollection      = undefined
            this._titleField            = undefined
            this._fieldsConfigString    = undefined
        } catch (e: any) {
            debug && console.warn(debug, 'fieldsConfigString error: ', e)
            this._fieldsConfigString = value
        }
    }

    get fieldsConfigString() {
        return !_.isNil(this.fieldsConfig) ? JSON.stringify(this.fieldsConfig, null, "\t") : ''
    }

    validate():ErrorProto[] | null  {
        const errors : any[] = []

        if (!this.name) errors.push(new ErrorFieldRequired(gd.fields.externalEntity.name))
        if (this._fieldsConfigString) {
            try {
                JSON.parse(this._fieldsConfigString)
            } catch (e: any) {
                debug && console.log(debug, 'validate error: ', e.message, this._fieldsConfigString)
                errors.push(new ErrorFieldCustom(gd.fields.externalEntity.fieldsConfigString, {message: e.message}))
            }
        }

        debug && console.log(debug, 'validate', errors)

        if (_.isEmpty(errors)) return null
        else return errors
    }

    async save():Promise<boolean> {

        const payload: any = {}

        debug && console.log(debug,"save", this.updatedFields)

        // Update
        this.updatedFields.forEach((fieldName) => {
            switch (fieldName) {
                default                 :
                    // @ts-ignore
                    payload[fieldName] = this[fieldName]
            }
        })
        this.updatedFields.clear()

        this.params.updatedFields.forEach((fieldName) => {
            if(!payload.params) payload.params = {}

            switch (fieldName) {
                default                 :
                    // @ts-ignore
                    payload.params[fieldName] = this[fieldName]
            }
        })
        this.params.updatedFields.clear()

        if (_.size(payload)>0) {
            await ApiCustomEntity.update(this).promise()
            return true
        }

        return false
    }

    toJSON() {
        return {
            id              : this.id,
            name            : this.name,
            type            : this.type,

            fieldsConfig    : this.fieldsConfig,
            params          : this.params.toJSON()
        }
    }
}
